import { render, staticRenderFns } from "./buy_bom.vue?vue&type=template&id=3322d606&scoped=true"
import script from "./buy_bom.vue?vue&type=script&lang=js"
export * from "./buy_bom.vue?vue&type=script&lang=js"
import style0 from "./buy_bom.vue?vue&type=style&index=0&id=3322d606&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3322d606",
  null
  
)

export default component.exports